import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { Button, Row, Col } from "react-bootstrap";
import { isBrowser } from "react-device-detect";
import { useNavigate } from "react-router-dom";

//STYLES
import * as BasketStyles from "../../styles/basket/basket";

//COMPONENTS
import Browser_BasketItem from "./basketItem_browser";
import Mobile_BasketItem from "./basketItem_mobile";
import BasketSideBar from "./basketSideBar";

//ACTIONS
import * as PrintingShopActions from "../../../../../../../envStore/actions/3dPrintingShop";

function Basket() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const printingShop = useSelector((state) => state.printingShop);
    const user = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(PrintingShopActions.FetchBasketDeatils());

        setTimeout(() => {
            console.log(printingShop);
            // handleCreatePaymentIntent();
        }, 5000);
    }, []);

    function handleGoToCheckout() {
        navigate("../checkout");
    }

    const browserDisplay = (
        <div style={BasketStyles.body}>
            <h1 style={BasketStyles.topHeading}>Your Basket</h1>
            {user.auth ? (
                <div>
                    {printingShop.items.length > 0 ? (
                        <Row>
                            <Col sm={2}></Col>
                            <Col sm={8}>
                                {printingShop.items.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <Browser_BasketItem
                                                BasketItem
                                                item={item}
                                                serverQuantity={printingShop.serverQuanities[item.uuid]}
                                                basketQuantity={printingShop.basketQuantities[item.uuid]}
                                            />

                                            <br />
                                        </div>
                                    );
                                })}
                            </Col>
                            <Col sm={2}>
                                <BasketSideBar />
                            </Col>
                        </Row>
                    ) : (
                        <div style={BasketStyles.topHeading}>There are no items in your basket</div>
                    )}
                </div>
            ) : (
                <div style={BasketStyles.topHeading}>Sign in to view your basket</div>
            )}
        </div>
    );

    const mobileDisplay = (
        <div style={BasketStyles.body}>
            <h1 style={BasketStyles.topHeading}>Your Basket</h1>
            {user.auth ? (
                <div>
                    {printingShop.items.length > 0 ? (
                        <div>
                            <div style={BasketStyles.mobile_topCheckoutInfo}>
                                <BasketSideBar />
                            </div>
                            {printingShop.items.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <Mobile_BasketItem
                                            item={item}
                                            serverQuantity={printingShop.serverQuanities[item.uuid]}
                                            basketQuantity={printingShop.basketQuantities[item.uuid]}
                                        />
                                        <br />
                                    </div>
                                );
                            })}
                            <div style={BasketStyles.mobile_bottomCheckoutButton}>
                                <Button variant="success" style={BasketStyles.checkoutButton} onClick={handleGoToCheckout}>
                                    Go To Checkout
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div style={BasketStyles.topHeading}>There are no items in your basket</div>
                    )}
                </div>
            ) : (
                <div style={BasketStyles.topHeading}>Sign in to view your basket</div>
            )}
        </div>
    );

    return <div>{isBrowser ? browserDisplay : mobileDisplay}</div>;
}

export default Basket;
